// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  componentKey: __t.string().name("component_key"),
  at: __t.timestamp(),
  ok: __t.bool(),
  httpCode: __t.u16().name("http_code"),
  latencyMs: __t.u32().name("latency_ms"),
  detail: __t.string(),
});
